import type { TeamStanding } from '@gymboard/types'

/**
 * Team scores are averages, so close battles differ by fractions. Show
 * whole numbers normally, but switch every team to one decimal when
 * rounding would make two teams look tied — otherwise the TV can say
 * "Team Blue wins!" above "Blue 5 · Red 5".
 */
export function formatTeamScores(teams: TeamStanding[]): (score: number) => string {
  const rounded = teams.map((t) => Math.round(t.score))
  const collide = new Set(rounded).size < rounded.length
  return collide ? (s) => s.toFixed(1) : (s) => String(Math.round(s))
}
